import { useId, ChangeEvent } from 'react';
import { DebounceInput } from 'react-debounce-input';
import style from './TextInput.module.css';

interface TextInputPropsInterface {
  name: string;
  value: string;
  type?: string;
  placeholder?: string;
  onChange?: (value: string) => void;
}

function TextInput(props: TextInputPropsInterface) {
  const {
    name,
    value,
    type,
    placeholder,
    onChange,
  } = props;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  return (
    <DebounceInput
      minLength={1}
      debounceTimeout={300}
      className={style.input}
      id={useId()}
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      autoComplete="off"
    />
  );
}

TextInput.defaultProps = {
  type: 'text',
  placeholder: '',
  onChange: () => {},
};

export default TextInput;
